import React from 'react';
import { SalesCounter } from './components/SalesCounter';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Showcase } from './components/Showcase';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { About } from './components/About';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-brand-dark text-brand-light font-sans selection:bg-brand-accent/50 selection:text-white" data-id="element-0">
      <SalesCounter data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <PainPoints data-id="element-4" />
      <Solution data-id="element-5" />
      <Modules data-id="element-6" />
      <Showcase data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <Benefits data-id="element-10" />
      <Testimonials data-id="element-11" />
      <ForWhom data-id="element-12" />
      <Pricing data-id="element-13" />
      <FAQ data-id="element-14" />
      <About data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </main>;
}